import React, {FC} from 'react';

import PeopleListItem from '/component/base/PeopleListItem';
import {generateCallback} from '/util/component.util';

interface PeopleDataProps {
  data: {
    currentCount: number;
    target: number;
  };
  detailVisible: boolean;
  getPeople: (data: {currentCount: number; target: number}) => any[];
  getTitle: (currentCount: number) => string;
  isComplete: boolean;
  onPress: () => void;
  personIsCoach: boolean;
}

const PeopleData: FC<PeopleDataProps> = ({
  data = {currentCount: 0, target: 0},
  detailVisible = false,
  getPeople = () => [],
  getTitle = () => '',
  isComplete = false,
  onPress = () => {},
  personIsCoach = false,
}: PeopleDataProps) => {
  const {currentCount, target} = data;

  return (
    <PeopleListItem
      currentCount={currentCount}
      expanded={detailVisible}
      hasCheckbox
      isChecked={isComplete}
      isCoach={personIsCoach}
      label={getTitle(currentCount)}
      onPress={generateCallback({func: onPress})}
      targetCount={target}
      peopleList={getPeople(data)}
      //NOTE: next two props temporary make peopleListItem unclickable
      canExpand={false}
      readonly
    />
  );
};

export default PeopleData;
